<div id="coordinators-view" class="page-layout blank">
    <div class="content">
        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
            <div class="widget" fxFlex="100" fxFlex.gt-sm="20">
                <app-coordinators-list [(nodeUpdate)]="nodeUpdateSend" (nodeChange)="nodeChangeEvent($event)"></app-coordinators-list>
            </div>
            <div  *ngIf="panelShow"  class="widget coordinators-management-view" fxFlex="100" fxFlex.gt-sm="80">
                <app-coordinators-detail (nodePanelHide)="nodeUpdateHidePanel($event)" (nodeUpdateTree)="nodeUpdateEvent($event)" [(nodeChangeGet)]="nodeChangeSend" ></app-coordinators-detail>
            </div>
        </div>
    </div>
</div> 